import { type FC, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useConsentManualConfigs } from '../../../../components/Consent/useConsentManualConfigs'

const MESSAGE_VISIBILITY_TIMEOUT_MS = 5 * 60 * 1000

export const InPersonComplianceMessage: FC = () => {
  const { inPersonComplianceMessage, userConsentTrackingEnabled } = useConsentManualConfigs()
  const [expired, setExpired] = useState(false)

  const messageEnabled = userConsentTrackingEnabled && !!inPersonComplianceMessage?.enabled && !!inPersonComplianceMessage.message

  useEffect(() => {
    if (!messageEnabled) {
      return
    }
    const timeout = setTimeout(() => setExpired(true), MESSAGE_VISIBILITY_TIMEOUT_MS)
    return () => clearTimeout(timeout)
  }, [messageEnabled])

  if (!messageEnabled || expired) {
    return null
  }

  return (
    <Row className='m-0'>
      <Col className='d-flex align-items-center gap-2 border zocks-border-color-gray-400 zocks-bg-color-gray-100 rounded-1 zocks-px-0.75 zocks-py-1.25'>
        <i className='bi bi-bell flex-shrink-0 zocks-text-primary' />
        <span className='paragraph-medium zocks-text-gray-900'>{inPersonComplianceMessage.message}</span>
      </Col>
    </Row>
  )
}
